import { colors } from '@flowwai-frontend/shared/style-guide'

const pmuPortalTheme = {
   light: {
      pmuUserHeader: {
         defaultBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         refreshIconColor: '!bg-base-white'
      },
      pmuUserBody: {
         documentPreviewBgColor: 'bg-gray-600',
         whiteHoverBgColor: 'hover:bg-white',
         defaultBorderColor: 'border-gray-300',
         dividerColor: 'border-gray-200',
         headerTextColor: 'text-gray-900',
         settingCardTitleColor: 'text-gray-800',
         userNameCardBgColor: 'bg-gray-50',
         labelColor: 'text-gray-500',
         descriptionColor: 'text-gray-600',
         userIconColorBg: 'bg-gray-100',
         alertIconFillColor: colors['error-100'],
         alertIconStrokeColor: colors['error-50'],
         iconColor: colors['gray-600'],
         textColor: 'text-gray-700',
         baseWhiteColor: 'bg-base-white',
         titleColor: 'text-gray-900',
         subtitleColor: 'text-gray-600',
         avatarBackgroundColor: 'bg-purple-100',
         avatarTextColor: 'text-purple-600',
         statusBadgeBackgroundColor: 'bg-green-100',
         statusDotColor: 'bg-green-500',
         statusTextColor: 'text-green-800',
         labelTextColor: 'text-gray-900',
         errorTextColor: 'text-error-500',
         resetOtpCounter: {
            loadingColor: colors['error-700'],
            loadingTextColor: 'text-error-700'
         },
         actionIcon: {
            transferUserIconColor: colors['lime-600'],
            initiateLeaveIconColor: colors['purple-600'],
            deactivateUserIconColor: colors['red-600'],
            endLeaveIconColor: colors['warning-600'],
            relieveOfficerIconColor: colors['pink-600'],
            updateUserIconColor: colors['cyan-600'],
            resetOtpIconColor: colors['warning-600'],
            transferUserBgColor: 'bg-lime-100',
            initiateLeaveBgColor: 'bg-purple-100',
            deactivateUserBgColor: 'bg-red-100',
            endLeaveBgColor: 'bg-warning-100',
            relieveOfficerBgColor: 'bg-pink-100',
            updateUserBgColor: 'bg-cyan-100',
            createOfficerBgColor: 'bg-success-100',
            resetOtpBgColor: 'bg-warning-100'
         },
         createOfficerCard: {
            iconBgColor: 'bg-success-100',
            iconColor: colors['success-600'],
            titleColor: 'text-gray-800'
         },
         loginAction: {
            textColor: 'text-gray-700',
            dateTimeColor: 'text-gray-800'
         },
         notifyUserModal: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600',
            userIconColorBg: 'bg-primary-100'
         },
         assignMandal: {
            checkIconColor: colors['base-white'],
            checkboxSelectedBgColor: 'bg-primary-600',
            checkboxSelectedBorderColor: 'border-primary-600',
            defaultBorderColor: 'border-gray-300',
            labelColor: 'text-gray-600'
         },
         pmuActionHeader: {
            backButtonColor: 'text-primary-600',
            backButtonHoverColor: 'hover:text-primary-700',
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600'
         },
         radioButton: {
            selectedContainerBg: 'bg-primary-25',
            selectedContainerBorder: 'border-primary-600',
            unselectedContainerBg: 'bg-base-white',
            unselectedContainerBorder: 'border-gray-300',
            selectedIconColor: 'bg-primary-600',
            selectedIconInnerColor: 'bg-base-white',
            unselectedIconColor: 'border-gray-300',
            titleTextColor: 'text-gray-700'
         },
         requiredIconColor: 'text-error-700',
         officerRadioGroup: {
            labelColor: 'text-gray-700',
            separatorColor: 'text-gray-500',
            requiredIconColor: 'text-error-700'
         },
         officerActionNote: {
            noteBackgroundColor: 'bg-warning-100',
            noteBorderColor: 'border-warning-300',
            textColor: 'text-gray-700'
         },
         relieveAndDistribute: {
            pipelineCard: {
               containerBgColor: 'bg-base-white',
               borderColor: 'border-gray-300',
               titleColor: 'text-gray-900',
               expandIconColor: colors['gray-500'],
               dividerColor: 'border-gray-200'
            },
            bucketPicker: {
               optionGroupNameColor: 'text-gray-900',
               optionOfficerNameColor: 'text-gray-500',
               emptyStateTextColor: 'text-gray-500'
            },
            reasonField: {
               requiredMarkerColor: 'text-error-700'
            },
            guidanceColor: 'text-gray-600',
            confirmationModal: {
               pipelineNameColor: 'text-gray-900',
               bucketNameColor: 'text-gray-900',
               groupNameColor: 'text-gray-500',
               sectionLabelColor: 'text-gray-900',
               helperTextColor: 'text-gray-600',
               detailLabelColor: 'text-gray-600',
               countTextColor: 'text-gray-500',
               officerNameColor: 'text-gray-900',
               cardBackgroundColor: 'bg-gray-50',
               cardBorderColor: 'border-gray-200',
               dividerColor: 'divide-gray-200',
               officerRowBackgroundColor: 'bg-base-white',
               officerRowBorderColor: 'border-gray-200',
               calloutBackgroundColor: 'bg-primary-25',
               calloutBorderColor: 'border-primary-200'
            }
         },
         replaceOfficer: {
            labelColor: 'text-gray-700',
            sectionLabelColor: 'text-gray-700',
            dividerColor: 'border-gray-200',
            errorBannerBgColor: 'bg-error-50',
            errorBannerBorderColor: 'border-error-300',
            errorBannerTextColor: 'text-error-700',
            errorBannerLinkColor: 'text-primary-600',
            reasonField: {
               requiredMarkerColor: 'text-error-700'
            },
            confirmationModal: {
               warningTextColor: 'text-error-700'
            }
         }
      },
      tdrManagementLogsHeader: {
         headerBgColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900'
      },
      pmuUserLogs: {
         bgColor: 'bg-gray-100',
         pmuOfficerLogCard: {
            borderColor: 'border-gray-300',
            titleTextColor: 'text-gray-800',
            timestampTextColor: 'text-gray-600',
            chevronColor: 'text-gray-500',
            descriptionBackgroundColor: 'bg-gray-50',
            descriptionTextColor: 'text-gray-700'
         },
         pmuUserLogsHeader: {
            defaultBorderColor: 'border-gray-300',
            headerTextColor: 'text-gray-900',
            refreshIconColor: '!bg-base-white',
            closeIconColor: colors['gray-500'],
            filterButtonStyle: 'border-primary-600'
         },
         filterConditionPills: {
            borderColor: 'border-gray-300',
            iconColors: colors['primary-600'],
            propertyIconColor: colors['primary-600'],
            tooltipArrowColor: colors['gray-900'],
            addFilterButton: {
               iconColor: colors['primary-600'],
               textColor: 'text-primary-700',
               borderColor: 'border-primary-600'
            },
            clearFilterButton: {
               iconColor: colors['gray-600'],
               textColor: 'text-gray-600'
            }
         },
         pmuUserLogCard: {
            dividerColor: 'border-gray-200',
            titleColor: 'text-gray-900',
            textColor: 'text-gray-800',
            labelColor: 'text-gray-600',
            reasonTextColor: 'text-gray-800',
            phoneNumberIconColor: colors['primary-600'],
            baseWhiteColor: 'bg-base-white',
            defaultBorderColor: 'border-gray-300',
            transferUserCard: {
               iconBgColor: 'bg-lime-200',
               iconColor: colors['lime-700']
            },
            deactivateUserCard: {
               iconBgColor: 'bg-red-200',
               iconColor: colors['red-700']
            },
            userDetailsUpdateCard: {
               iconBgColor: 'bg-primary-200',
               iconColor: colors['primary-500']
            },
            resetOtpCard: {
               iconBgColor: 'bg-warning-200',
               iconColor: colors['warning-600']
            },
            userLeaveCard: {
               leaveStartIconBgColor: 'bg-purple-200',
               leaveStartIconColor: colors['purple-600'],
               leaveEndIconBgColor: 'bg-warning-200',
               leaveEndIconColor: colors['warning-600'],
               iconBgColor: 'bg-warning-500',
               iconColor: colors['base-white']
            },
            relieveAndDistributeCard: {
               errorTextColor: 'text-error-600',
               usernameColor: 'text-gray-500'
            },
            relieveApprovalGate: {
               sectionBorderColor: 'border-gray-200',
               downloadTextColor: 'text-primary-700'
            },
            replaceOfficerCard: {
               errorTextColor: 'text-error-600',
               usernameColor: 'text-gray-500',
               partialTextColor: 'text-orange-700'
            },
            replaceApprovalGate: {
               sectionBorderColor: 'border-gray-200',
               downloadTextColor: 'text-primary-700',
               warningTextColor: 'text-warning-700'
            }
         },
         officerLogs: {
            defaultBorderColor: 'border-gray-300',
            titleColor: 'text-gray-700',
            descriptionColor: 'text-gray-500'
         }
      },
      resetOtpCounter: {
         loadingColor: colors['error-700'],
         loadingTextColor: 'text-error-700'
      },
      applicationManagementLogsHeader: {
         headerBgColor: 'bg-base-white',
         defaultBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900'
      },
      applicationManagementLogCard: {
         dividerColor: 'border-gray-200',
         titleColor: 'text-gray-900',
         textColor: 'text-gray-800',
         labelColor: 'text-gray-600',
         baseWhiteColor: 'bg-base-white',
         taskShortfallCard: {
            iconBgColor: 'bg-primary-100',
            iconColor: colors['primary-600']
         },
         pullbackCard: {
            iconBgColor: 'bg-primary-100',
            iconColor: colors['primary-600']
         },
         fieldDiffList: {
            wrapperBorderColor: 'border-gray-200',
            headerBgColor: 'bg-gray-50',
            headerTextColor: 'text-gray-500',
            rowBorderColor: 'border-gray-100',
            addedRowBorderColor: 'border-l-success-500',
            deletedRowBorderColor: 'border-l-error-500',
            labelColor: 'text-gray-700',
            oldValueColor: 'text-gray-400',
            newValueColor: 'text-gray-900',
            addedValueColor: 'text-success-600',
            mutedColor: 'text-gray-400',
            emptyTextColor: 'text-gray-500'
         },
         transferCard: {
            errorTextColor: 'text-error-700',
            errorBgColor: 'bg-error-50',
            errorBorderColor: 'border-error-200',
            statusBadgeVariant: {
               INITIATED: 'BLUE',
               IN_PROGRESS: 'WARNING',
               COMPLETED: 'SUCCESS',
               FAILED: 'ERROR',
               PARTIAL_SUCCESS: 'ORANGE'
            }
         },
         loginPhoneUpdateCard: {
            oldValueColor: 'text-gray-500',
            newValueColor: 'text-gray-900',
            arrowColor: 'text-gray-400',
            errorColor: 'text-error-600'
         }
      },
      applicationManagementActionIcon: {
         taskShortfallBgColor: 'bg-warning-200',
         taskShortfallIconColor: colors['warning-600'],
         untriggerLineDepartmentBgColor: 'bg-purple-100',
         untriggerLineDepartmentIconColor: colors['purple-600'],
         transferApplicationBgColor: 'bg-blue-100',
         transferApplicationIconColor: colors['blue-600'],
         decrementShortfallCounterBgColor: 'bg-orange-100',
         decrementShortfallCounterIconColor: colors['orange-600'],
         pullBackApplicationBgColor: 'bg-primary-100',
         pullBackApplicationIconColor: colors['primary-600'],
         updateLoginPhoneBgColor: 'bg-blue-100',
         updateLoginPhoneIconColor: colors['blue-600']
      },
      applicationManagement: {
         header: {
            defaultBorderColor: 'border-gray-300',
            headerTextColor: 'text-gray-900'
         },
         searchBody: {
            titleColor: 'text-gray-700'
         },
         searchAsyncComboBox: {
            optionTextColor: 'text-gray-900',
            optionHoverBgColor: 'hover:bg-gray-100',
            iconStrokeColor: colors['gray-600']
         },
         actionButton: {
            textColor: 'text-gray-700'
         },
         applicationManagementADVHeader: {
            notSectionTitleColor: 'text-warning-700',
            notSectionBgColor: 'bg-warning-25',
            notSectionBorderColor: 'border-warning-300',
            labelColor: 'text-gray-600',
            valueColor: 'text-gray-800',
            refreshIconColor: colors['gray-700'],
            iconColor: colors['warning-700']
         },
         searchAndActions: {
            detailsPanel: {
               labelColor: 'text-gray-600',
               valueColor: 'text-gray-900'
            },
            actionsList: {
               containerBgColor: 'bg-white',
               titleColor: 'text-gray-900',
               rowTextColor: 'text-gray-900',
               disabledRowTextColor: 'text-gray-400',
               rowBorderColor: 'border-gray-200',
               iconColor: colors['primary-600'],
               // Loading / error / empty states: previously uncoloured, so the
               // text inherited whatever the ancestor set and the panel read as
               // blank when no actions came back.
               stateTitleColor: 'text-gray-700',
               stateDescriptionColor: 'text-gray-500',
               stateIconColor: colors['gray-400'],
               stateIconBgColor: 'bg-gray-100'
            },
            noApplication: {
               titleColor: 'text-gray-700',
               descriptionColor: 'text-gray-500',
               iconColor: colors['gray-400'],
               iconBgColor: 'bg-gray-100'
            }
         },
         fileTransfer: {
            form: {
               unsupportedFieldTextColor: 'text-gray-500',
               notConfiguredIconColor: colors['warning-500'],
               // Interim fail-loud guard (referenceFieldId contract gap) —
               // an error, not a warning: submit is blocked, not just risky.
               unsubmittableFieldsTextColor: 'text-error-700',
               unsubmittableFieldsIconColor: colors['error-600']
            },
            // Minimal modal chrome for `FileTransferModalController` — a
            // stand-in for plan.md Task 13's fuller FORM|SUBMITTING|SUCCESS
            // controller, which owns the confirm/success theming.
            modal: {
               containerBgColor: 'bg-white',
               borderColor: 'border-gray-200',
               titleColor: 'text-gray-900',
               labelColor: 'text-gray-700',
               // `Loader` paints with `currentColor`; the loading container
               // carries this as its text colour so the spinner is visible.
               loadingTextColor: 'text-gray-600'
            }
         },
         shortfallCounterDecrement: {
            modal: {
               containerBgColor: 'bg-white',
               borderColor: 'border-gray-200',
               titleColor: 'text-gray-900',
               labelColor: 'text-gray-700',
               loadingTextColor: 'text-gray-600',
               counterCardBgColor: 'bg-gray-50',
               counterLabelColor: 'text-gray-600',
               counterValueColor: 'text-gray-900',
               counterNextValueColor: 'text-primary-700',
               counterErrorTextColor: 'text-error-700'
            }
         },
         pullback: {
            modal: {
               containerBgColor: 'bg-base-white',
               borderColor: 'border-gray-200',
               titleColor: 'text-gray-900',
               labelColor: 'text-gray-700',
               loadingTextColor: 'text-primary-600'
            },
            nowline: {
               bgColor: 'bg-gray-50',
               textColor: 'text-gray-600'
            },
            footer: {
               borderColor: 'border-gray-200',
               textColor: 'text-gray-600'
            },
            emphasis: {
               textColor: 'text-gray-900'
            },
            statusPill: {
               STARTING: 'GRAY' as const,
               READING: 'BLUE' as const,
               AWAITING_APPROVAL: 'BLUE' as const,
               BLOCKED: 'ERROR' as const,
               RUNNING: 'BLUE' as const,
               SUCCEEDED: 'SUCCESS' as const,
               REJECTED: 'GRAY' as const,
               TIMED_OUT: 'GRAY' as const,
               CANCELLED: 'GRAY' as const,
               FAILED: 'ERROR' as const
            },
            stagePill: {
               variant: 'ORANGE' as const
            },
            tag: {
               required: 'BLUE' as const,
               optional: 'GRAY' as const,
               blocked: 'ERROR' as const,
               couldBeUndone: 'GRAY' as const,
               informational: 'GRAY' as const
            },
            tickButton: {
               borderColor: 'border-gray-300',
               bgColor: 'bg-base-white',
               textColor: 'text-gray-700',
               hoverBgColor: 'hover:bg-gray-50',
               tickedBgColor: 'bg-primary-50',
               tickedBorderColor: 'border-primary-200',
               tickedTextColor: 'text-primary-700',
               tickedHoverBgColor: 'hover:bg-primary-100',
               disabledBgColor: 'bg-gray-100',
               disabledBorderColor: 'border-gray-200',
               disabledTextColor: 'text-gray-400',
               focusRingColor: 'focus-visible:ring-primary-100'
            },
            thinkbar: {
               bgColor: 'bg-primary-25',
               borderColor: 'border-primary-100',
               textColor: 'text-primary-800',
               orbColor: 'bg-primary-500',
               caretColor: 'bg-primary-600',
               sheenColor: 'via-primary-600/10',
               doneBgColor: 'bg-gray-50',
               doneBorderColor: 'border-gray-200',
               doneTextColor: 'text-gray-700'
            },
            infoNote: {
               bgColor: 'bg-gray-50',
               borderColor: 'border-gray-200',
               textColor: 'text-gray-500',
               iconColor: colors['gray-500']
            },
            endingLayout: {
               titleColor: 'text-gray-900',
               bodyColor: 'text-gray-600',
               glyphColor: colors['base-white'],
               successIconColor: colors['primary-600'],
               mutedIconColor: colors['gray-400'],
               warningIconColor: colors['warning-500'],
               errorIconColor: colors['error-600']
            },
            runningStrip: {
               bgColor: 'bg-primary-25',
               borderColor: 'border-primary-100',
               textColor: 'text-primary-800',
               dotColor: 'bg-primary-600',
               linkColor: 'text-primary-800'
            },
            noticeCard: {
               defaultBorderColor: 'border-gray-300',
               defaultBgColor: 'bg-base-white',
               warnBorderColor: 'border-warning-200',
               warnBgColor: 'bg-warning-50',
               errorBorderColor: 'border-error-200',
               errorBgColor: 'bg-error-25',
               titleColor: 'text-gray-900',
               bodyColor: 'text-gray-600'
            },
            stageRadioList: {
               ringColor: 'border-gray-300',
               ringSelectedColor: 'border-primary-600',
               defaultBorderColor: 'border-gray-300',
               hoverBorderColor: 'hover:border-primary-400',
               hoverBgColor: 'hover:bg-primary-25',
               selectedBorderColor: 'border-primary-600',
               selectedBgColor: 'bg-primary-25',
               metaColor: 'text-gray-500',
               focusRingColor: 'focus-visible:ring-primary-100'
            },
            startForm: {
               labelColor: 'text-gray-700',
               errorColor: 'text-error-600'
            },
            readingView: {
               skeletonBorderColor: 'border-gray-200',
               skeletonBgColor: 'bg-base-white',
               skeletonGradientColor: 'from-gray-100 via-gray-200 to-gray-100'
            },
            changeRow: {
               borderColor: 'border-gray-300',
               bgColor: 'bg-base-white',
               blockedBorderColor: 'border-error-200',
               blockedBgColor: 'bg-error-25',
               ghostBorderColor: 'border-gray-200',
               ghostBgColor: 'bg-gray-25',
               highlightBorderColor: 'border-warning-300',
               titleColor: 'text-gray-900',
               ghostTitleColor: 'text-gray-600',
               effectColor: 'text-gray-600',
               blockedReasonColor: 'text-error-700',
               metaColor: 'text-gray-600',
               blockedMetaColor: 'text-error-700',
               missingTimeColor: 'text-gray-400',
               arrowColor: 'text-gray-400',
               lockIconColor: colors['error-600'],
               clockIconColor: colors['gray-400'],
               blockedClockIconColor: colors['error-400']
            },
            changeList: {
               groupTitleColor: 'text-gray-500',
               ruleColor: 'bg-gray-200',
               countColor: 'text-gray-500'
            },
            reviewView: {
               tallyBgColor: 'bg-gray-50',
               tallyBorderColor: 'border-gray-200',
               tallyFoundColor: 'text-gray-900',
               tallyUndoColor: 'text-primary-700',
               tallyLabelColor: 'text-gray-500',
               noteColor: 'text-gray-500',
               expiryBgColor: 'bg-gray-50',
               expiryBorderColor: 'border-gray-200',
               expiryTextColor: 'text-gray-500',
               expiryIconColor: colors['gray-400']
            },
            executionBoard: {
               stepBorderColor: 'border-gray-300',
               stepBgColor: 'bg-base-white',
               stepRunBorderColor: 'border-primary-300',
               stepRunBgColor: 'bg-primary-25',
               itemBorderColor: 'border-gray-200',
               nameColor: 'text-gray-900',
               subColor: 'text-gray-500',
               statePendingColor: 'text-gray-400',
               stateRunColor: 'text-primary-700',
               stateDoneColor: 'text-primary-700',
               stateSkipColor: 'text-gray-400',
               itemColor: 'text-gray-500',
               itemRunColor: 'text-gray-800',
               itemDoneColor: 'text-gray-700',
               markBorderColor: 'border-gray-300',
               markRunBorderColor: 'border-primary-100 border-t-primary-600',
               markDoneBgColor: 'bg-primary-600',
               markGlyphColor: 'text-base-white'
            },
            resultView: {
               recoverBgColor: 'bg-warning-50',
               recoverBorderColor: 'border-warning-200',
               recoverTextColor: 'text-warning-800',
               recoverIconColor: colors['warning-700'],
               logLineColor: 'text-gray-500',
               blockingBorderColor: 'border-error-200',
               blockingBgColor: 'bg-error-25',
               blockingTitleColor: 'text-gray-700',
               blockingReasonColor: 'text-error-700',
               lockIconColor: colors['error-600']
            }
         },
         updateLoginPhone: {
            containerBgColor: 'bg-white',
            borderColor: 'border-gray-200',
            titleColor: 'text-gray-900',
            labelColor: 'text-gray-700',
            requiredIconColor: 'text-error-700',
            closeIconColor: colors['gray-600'],
            sectionTitleColor: 'text-gray-900',
            footerHintColor: 'text-gray-500',
            subtitleColor: 'text-gray-500',
            loginLostColor: 'text-error-600',
            dividerColor: 'border-gray-200',
            loginTypePicker: {
               optionTextColor: 'text-gray-700',
               borderColor: 'border-gray-300',
               hoverBgColor: 'hover:bg-gray-50',
               selectedBgColor: 'bg-primary-50',
               selectedTextColor: 'text-primary-700',
               unavailableTextColor: 'text-gray-400',
               unavailableBgColor: 'bg-gray-100',
               focusRingColor: 'focus-visible:ring-primary-100'
            },
            currentNumber: {
               stripBgColor: 'bg-gray-50',
               stripBorderColor: 'border-gray-200',
               iconColor: colors['gray-500'],
               labelColor: 'text-gray-500',
               valueColor: 'text-gray-900',
               emptyColor: 'text-gray-500',
               errorColor: 'text-error-600',
               retryLinkColor: 'text-primary-700',
               loaderColor: colors['primary-600']
            },
            newNumber: {
               prefixColor: 'text-gray-600',
               prefixBorderColor: 'border-gray-300',
               hintColor: 'text-gray-500',
               errorColor: 'text-error-600'
            },
            otp: {
               hintColor: 'text-gray-500',
               errorColor: 'text-error-600',
               resendLinkColor: 'text-primary-700',
               resendDisabledColor: 'text-gray-400'
            },
            summaryCard: {
               bgColor: 'bg-gray-50',
               borderColor: 'border-gray-200',
               labelColor: 'text-gray-500',
               valueColor: 'text-gray-900',
               oldValueColor: 'text-gray-500',
               arrowColor: colors['gray-400'],
               mutedColor: 'text-gray-500'
            },
            stepError: {
               bgColor: 'bg-error-50',
               borderColor: 'border-error-300',
               textColor: 'text-error-700'
            }
         }
      },
      tdrManagement: {
         onHoldTdrCertificate: {
            titleColor: 'text-gray-900',
            headerBorderColor: 'border-gray-300',
            containerBgColor: 'bg-gray-50'
         },
         releaseTdrCertificate: {
            titleColor: 'text-gray-900',
            headerBorderColor: 'border-gray-300'
         },
         releaseCertificateFormModal: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-500',
            borderColor: 'border-gray-300',
            containerBgColor: 'bg-white',
            requiredIconColor: 'text-error-700'
         },
         otpVerificationCard: {
            checkIconBgColor: 'bg-success-100',
            checkIconColor: colors['success-600'],
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-600',
            mobileNumberColor: 'text-gray-900',
            errorMessageColor: 'text-error-500',
            resendButtonColor: 'text-primary-600'
         },
         onHoldCertificateForm: {
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-500',
            borderColor: 'border-gray-200',
            containerBgColor: 'bg-white',
            detailsBorderColor: 'border-gray-200',
            detailsBgColor: 'bg-gray-50',
            detailLabelColor: 'text-gray-500',
            detailValueColor: 'text-gray-700',
            certificateDetailDividerColor: 'bg-gray-400',
            viewLedgerColor: 'text-primary-600',
            helperTextColor: 'text-gray-500',
            requiredIconColor: 'text-error-700',
            checkboxLabelColor: 'text-gray-700'
         },
         tdrManagementFileUploader: {
            labelColor: 'text-gray-700',
            errorTextColor: 'text-error-500'
         }
      },
      untriggerLineDepartment: {
         containerBgColor: 'bg-white',
         borderColor: 'border-gray-200',
         titleColor: 'text-gray-900',
         labelColor: 'text-gray-700',
         hintColor: 'text-gray-500',
         requiredIconColor: 'text-error-700',
         emptyStateTextColor: 'text-gray-500',
         closeIconColor: colors['gray-600'],
         emptyState: {
            iconBgColor: 'bg-gray-100',
            iconColor: colors['gray-600'],
            titleColor: 'text-gray-900',
            descriptionColor: 'text-gray-500'
         },
         pipelineCard: {
            defaultBorderColor: 'border-gray-200',
            defaultBgColor: 'bg-white',
            hoverBorderColor: 'hover:border-primary-300',
            selectedBorderColor: 'border-primary-500',
            selectedBgColor: 'bg-primary-50',
            nameColor: 'text-gray-800'
         },
         confirm: {
            // Row colours live in `lineDepartmentPipelineRow` — the row is a
            // shared component, used here and by the untrigger log card.
            listLabelColor: 'text-gray-700'
         }
      },
      lineDepartmentPipelineRow: {
         borderColor: 'border-gray-200',
         bgColor: 'bg-gray-50',
         nameColor: 'text-gray-800'
      },
      taskShortfall: {
         titleColor: 'text-gray-900',
         descriptionColor: 'text-gray-500',
         borderColor: 'border-gray-300',
         containerBgColor: 'bg-white',
         requiredIconColor: 'text-error-700',
         fileUploaderLabelColor: 'text-gray-700',
         fileUploaderErrorTextColor: 'text-error-500',
         closeIconColor: colors['gray-600']
      },
      taskShortfallModal: {
         bodyBgColor: 'bg-gray-50'
      },
      tdrManagementLogDetailsSidePane: {
         defaultBorderColor: 'border-gray-300',
         defaultTextColor: 'text-gray-800',
         headerTextColor: 'text-gray-900',
         sectionTitleColor: 'text-gray-700',
         noContentColor: 'text-gray-500'
      },
      tdrManagementLogsFilterSidepane: {
         defaultBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         closeIconColor: colors['gray-500']
      },
      applicationManagementLogsFilterSidepane: {
         defaultBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         closeIconColor: colors['gray-500']
      }
   },
   dark: {}
}

export default pmuPortalTheme
